import { render, staticRenderFns } from "./FichasItems.vue?vue&type=template&id=cab89fa2"
import script from "./FichasItems.vue?vue&type=script&lang=js"
export * from "./FichasItems.vue?vue&type=script&lang=js"
import style0 from "./FichasItems.vue?vue&type=style&index=0&id=cab89fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports